/*
  rk Produktkarte: „Kaufen“ legt die Variante per Cart-AJAX in den Warenkorb
  und öffnet den Warenkorb-Drawer. Ohne Drawer oder ohne JS wird das Formular
  normal abgeschickt (→ /cart).
*/
(() => {
  if (window.RkProductCard) return;
  window.RkProductCard = true;

  const setStatus = (form, message) => {
    const status = form.closest('.rk-card')?.querySelector('[data-rk-card-status]');
    if (status) status.textContent = message || '';
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-rk-card-form]');
    if (!form) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' || !window.routes || typeof fetchConfig !== 'function') return;

    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    const variantId = parseInt(form.querySelector('[name="id"]').value, 10);
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-rk-loading');
    setStatus(form, '');

    try {
      const response = await fetch(window.routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: cartDrawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();

      if (data.status) {
        setStatus(form, data.description || data.message);
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rk-product-card', productVariantId: variantId, cartData: data });
      }
      cartDrawer.classList.remove('is-empty');
      cartDrawer.setActiveElement?.(button);
      cartDrawer.renderContents(data);
    } catch (error) {
      console.error(error);
      form.submit();
    } finally {
      button.removeAttribute('aria-busy');
      button.classList.remove('is-rk-loading');
    }
  });
})();
